import React from 'react';
import DatePicker from '../DatePicker';

const TimePicker = props => <DatePicker {...props} isTimePicker />;

export default TimePicker;
